import InfoPopper from "../components/InfoPopper";

interface IProps {
  children: React.ReactElement;
  title: string;
  subTitle?: string | React.ReactElement;
  infoMessage: any;
  loading: boolean;
  height?: number;
}

const BaseGraph = ({
  children,
  title,
  subTitle,
  infoMessage,
  loading,
  height,
}: IProps) => {
  // const [uom] = useStore((state) => [state.uom]);

  return (
    <div
      style={{
        border: "1px solid lightgray",
        borderRadius: 4,
        padding: 20,
        // maxWidth: 578,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexGrow: 1,
            gap: 30,
          }}
        >
          <div
            style={{
              fontWeight: 700,
              fontSize: 18,
              color: "#0F2C52",
              fontFamily: "TradeGothic LT Cond20",
            }}
          >
            {title}
          </div>
          {subTitle && subTitle}
        </div>

        <InfoPopper message={infoMessage} />
      </div>
      <div style={{ height, width: "100%", paddingTop: 8 }}>
        {/* {props.loading && <Loading size={100} />} */}
        {!loading && children}
      </div>
    </div>
  );
};

export default BaseGraph;
